// LoadingPage.jsx
import React, { useEffect } from "react";
import { gsap } from "gsap";
import "./loadingpage.css";

export function LoadingPage() {
	//   useEffect(() => {
	//     // Animate loading page opacity and hide it after delay
	//     gsap.fromTo(
	//       ".loading-page",
	//       { opacity: 1 },
	//       { opacity: 0, display: "none", duration: 1.5, delay: 3.5 }
	//     );

	//     // Animate logo-name with bounce effect
	//     gsap.fromTo(
	//       ".logo-name",
	//       { y: 50, opacity: 0 },
	//       { y: 0, opacity: 1, duration: 2, delay: 0.5 }
	//     );

	//     // Add stroke animation for SVG paths (assign className "logo-path" to paths)
	//     gsap.fromTo(
	//       ".logo-path",
	//       { strokeDasharray: 1000, strokeDashoffset: 1000 },
	//       { strokeDashoffset: 0, duration: 2.5, delay: 0.5, ease: "power2.out" }
	//     );
	//   }, []);


	useEffect(() => {
		const paths = document.querySelectorAll(".logo-path");

		paths.forEach((path, i) => {
			const length = path.getTotalLength();
			path.style.strokeDasharray = length;
			path.style.strokeDashoffset = length;

			gsap.to(path, {
				strokeDashoffset: 0,
				duration: 2,
				delay: i * 0.2, // stagger each path
				ease: "power2.out",
			});

			// Optional: fade in fill after stroke animation
			gsap.to(path, {
				//   fill: "#FFFFFF",
				fill: "#000292ff",
				duration: 0.5,
				delay: 2 + i * 0.2,
			});
		});

		// Animate the text/logo name
		gsap.fromTo(
			".logo-name",
			{ y: 50, opacity: 0 },
			{ y: 0, opacity: 1, duration: 2, delay: 2.5 }
		);

		// Hide the loading page after all animations
		gsap.to(".loading-page", { opacity: 0, display: "none", duration: 1, delay: 4 });
	}, []);
	return (
		<div className="loading-page">
			<svg
				id="svg"
				xmlns="http://www.w3.org/2000/svg"
				x="0px"
				y="0px"
				width="100%"
				viewBox="0 0 807 720"
				enableBackground="new 0 0 807 720"
				xmlSpace="preserve"
			>
				<path className="logo-path" fill="none" stroke="#FFFFFF" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" d="

M48.000000,107.500000 
	C50.136501,116.660095 54.469440,119.237312 65.001007,119.450348 
	C75.996506,119.672760 87.000031,119.514732 97.999992,119.494606 
	C104.875702,119.482025 110.461067,115.069916 112.000000,108.500000 
	C113.949532,100.177193 111.214546,93.809166 104.529030,90.442360 
	C102.682297,89.512337 100.885941,89.507759 98.999992,89.505928 
	C87.000008,89.494270 75.000000,89.500000 63.000000,89.500000 
	C53.728107,89.500008 49.461361,93.476387 48.495697,102.999565 
	C48.360176,104.336060 48.166668,105.666664 48.000000,107.000000 
" />
				<path className="logo-path" fill="none" stroke="#FFFFFF" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" d="
M271.500000,34.500000 
	C269.863129,35.913956 267.882385,35.490643 266.000000,35.491718 
	C243.500000,35.504547 220.994858,35.791019 198.501877,35.393909 
	C184.376083,35.144524 179.452484,46.093872 182.551697,57.485935 
	C183.858032,62.287731 189.331802,65.849304 195.000427,65.981430 
	C204.998886,66.214470 215.002167,66.253853 224.999268,66.526764 
	C232.169693,66.722511 239.410721,66.626907 246.479858,67.640480 
	C254.790009,68.831970 259.898865,76.578583 253.958923,83.966972 
	C251.740417,86.726433 248.860168,88.719948 244.999939,88.501205 
	C244.833786,88.491791 244.666672,88.499214 244.500000,88.500114 
	C213.666672,88.666672 182.833374,88.842979 151.999969,88.994446 
	C142.052170,89.043320 137.726440,93.572548 137.416412,103.497391 
	C137.225647,109.604057 138.457474,115.217484 144.109207,117.756935 
	C147.713943,119.376633 152.241226,119.552498 156.500137,119.535500 
	C176.499817,119.455658 196.504364,119.756721 216.498581,119.416405 
	C231.694687,119.157753 246.829849,120.682564 261.998535,120.415916 
	C269.536133,120.283417 273.140320,125.309181 273.873108,130.019745 
	C274.619354,134.816940 268.551636,140.799057 262.997101,141.476288 
	C261.683289,141.636459 260.333344,141.500000 259.000000,141.500000 
	C235.833328,141.500000 212.666077,141.410477 189.500443,141.565964 
	C184.036041,141.602646 178.598740,142.623444 175.015930,147.511673 
	C170.422943,153.778168 171.393463,168.428497 180.466995,171.594574 
	C182.350357,172.251770 184.114105,172.494095 186.000000,172.494385 
	C231.666672,172.501572 277.342590,173.024521 322.995056,172.220047 
	C339.324463,171.932281 355.676453,171.422668 371.997986,171.647217 
	C388.846710,171.878998 405.713898,171.870026 422.541321,174.201691 
	C429.597412,175.179398 436.988007,175.425354 443.947601,176.771042 
	C454.541840,178.819519 465.213989,180.876114 475.527679,184.419479 
	C489.049835,189.065170 501.796967,195.001953 513.001648,203.997940 
	C523.995422,212.824585 532.178650,223.714417 536.980286,237.007126 
	C541.952209,250.771255 539.167969,263.913727 532.936279,276.468384 
	C526.521423,289.392120 516.303589,299.020477 504.410950,306.864990 
	C503.175964,307.679565 501.679138,308.476959 501.126282,309.564209 
	C500.241394,311.304260 499.227264,313.847473 502.999420,314.012970 
	C505.169220,314.108154 507.417572,314.800171 509.486816,314.426849 
	C527.526489,311.172394 545.634705,308.105988 562.988220,301.966614 
	C582.069885,295.215942 599.947571,286.454407 615.626404,273.148956 
	C629.046997,261.759888 638.953491,247.997528 646.316711,232.413406 
	C650.369385,223.835892 652.801025,214.550308 654.828430,205.070236 
	C657.488586,192.630783 656.752136,180.269424 656.168823,168.015762 
	C655.642273,156.956421 652.082092,146.110260 647.013550,135.993210 
	C638.670349,119.339836 626.846497,105.602356 611.968262,94.542709 
	C600.526367,86.037483 588.684631,78.052933 575.968689,71.561317 
	C564.186829,65.546570 552.046326,60.257442 539.494080,56.017605 
	C520.763306,49.690823 501.629669,45.160271 482.017273,42.378155 
	C469.706543,40.631813 457.391205,39.440907 445.018402,38.300430 
	C418.370819,35.844158 391.652039,36.682766 365.007965,35.341511 
	C333.994293,33.780289 302.997101,35.103489 272.000000,34.500000 
" />
				<path className="logo-path" fill="none" stroke="#FFFFFF" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" d="
M116.500000,50.000000 
	C110.930473,50.527618 105.788330,51.584259 102.434601,56.959194 
	C98.956673,62.533184 100.128654,68.519089 102.341919,73.343124 
	C104.455078,77.948952 109.408928,80.766457 115.502678,80.595200 
	C127.160133,80.267586 138.833328,80.504471 150.500000,80.498543 
	C159.272949,80.494087 164.090744,75.236824 164.608231,66.506416 
	C165.195679,56.595917 161.027054,52.533775 155.977188,51.079170 
	C153.272278,50.300030 150.336258,50.078480 147.499466,50.045837 
	C137.334152,49.928879 127.166664,50.000000 117.000000,50.000000 
" />
				<path className="logo-path" fill="none" stroke="#FFFFFF" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" d="
M106.999992,126.499992 
	C104.666664,127.833328 101.730896,128.663239 100.115402,130.596451 
	C95.655724,135.933258 96.720253,142.600555 98.247528,148.435211 
	C99.672562,153.879211 104.759941,156.428345 110.500214,156.471527 
	C122.832855,156.564331 135.168106,156.613724 147.499481,156.458466 
	C155.225372,156.361221 160.798172,151.996002 161.389893,144.990692 
	C162.136978,136.146133 159.938187,130.078186 152.970688,127.067833 
	C151.505524,126.434784 149.667084,126.526932 147.999939,126.522079 
	C134.500046,126.482750 121.000000,126.500000 107.500000,126.500000 
" />
				<path className="logo-path" fill="none" stroke="#FFFFFF" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" d="
M663.000000,153.500000 
	C660.196716,154.705170 661.477112,157.217789 661.608337,158.991989 
	C661.955261,163.682312 662.941040,168.320969 663.478882,173.002411 
	C664.842712,184.874466 664.921326,196.572220 662.788208,208.551315 
	C660.663818,220.481400 657.357422,231.838394 651.888733,242.442627 
	C643.705627,258.310486 632.558350,271.704010 618.116699,282.653900 
	C602.210999,294.713898 584.624268,303.110748 565.958252,309.375580 
	C553.626282,313.514496 540.868652,316.210663 528.046448,318.735779 
	C515.085327,321.288208 501.837036,321.438782 488.996613,324.485718 
	C488.523254,324.598022 487.999786,324.490051 487.500031,324.501465 
	C473.000000,324.832977 458.490173,324.933624 444.001892,325.544922 
	C404.842041,327.197113 365.652222,325.692871 326.508484,326.800140 
	C313.683624,327.162872 300.657867,328.877411 287.993958,331.975250 
	C275.954315,334.920349 264.197174,338.419342 252.946030,343.888977 
	C232.917374,353.625732 218.077591,367.954315 208.892029,388.451630 
	C201.429901,405.103119 199.080505,422.549377 197.263962,440.476074 
	C194.627411,466.495270 195.366501,492.510529 195.836746,518.493896 
	C196.034775,529.436401 195.404907,540.568909 197.377625,551.522034 
	C197.782578,553.770447 198.510986,554.993713 200.495239,554.899597 
	C201.937469,554.831177 203.146149,554.286682 203.631653,552.028320 
	C206.930817,536.682068 215.399231,524.236511 226.527359,513.528442 
	C238.881790,501.640350 254.123611,494.662323 270.016785,489.047516 
	C284.727325,483.850464 300.094604,481.410217 315.515320,479.633057 
	C321.116974,478.987488 326.838287,478.966949 332.506470,478.599762 
	C345.152435,477.780518 357.834839,477.535156 370.499634,476.991638 
	C389.167694,476.190521 407.891510,475.967865 426.478424,474.264435 
	C437.813232,473.225616 449.226135,472.705963 460.557312,470.849945 
	C467.383850,469.731750 474.435699,468.685120 481.494843,468.380432 
	C486.521454,468.163452 491.518066,466.927521 496.494659,465.972229 
	C501.019897,465.103577 505.537994,464.144379 509.992706,462.972290 
	C522.286499,459.737640 534.544006,456.558899 546.606262,452.301025 
	C560.021790,447.565460 572.968628,442.086304 585.488525,435.478302 
	C601.375366,427.093201 616.059753,416.881500 629.455811,404.950378 
	C645.253540,390.880219 659.574646,375.438477 671.001831,357.501160 
	C679.886108,343.555511 687.077637,328.772919 691.918884,312.975159 
	C695.551270,301.122192 697.889465,289.053131 698.767334,276.518707 
	C699.767151,262.243774 699.691284,248.122147 697.940491,234.007385 
	C695.716003,216.073441 689.986694,199.068314 682.941284,182.525024 
	C679.136902,173.592209 674.254639,165.179352 669.016418,156.989502 
	C667.692566,154.919708 666.230225,153.257263 663.500000,153.500000 
" />
				<path className="logo-path" fill="none" stroke="#FFFFFF" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" d="
M333.000000,485.500000 
	C329.666656,486.166656 326.271576,487.604584 323.012512,487.343628 
	C315.642822,486.753479 308.523010,488.395905 301.541321,489.718231 
	C286.111328,492.640656 270.938446,496.908234 257.012604,504.523041 
	C234.446625,516.862427 218.271942,534.917725 209.010803,559.004150 
	C205.704773,567.602478 203.459106,576.472046 201.272797,585.444641 
	C197.152039,602.356079 197.909927,619.409973 197.365524,636.495728 
	C197.009003,647.685120 197.951187,658.828979 197.561905,670.002136 
	C197.409882,674.365356 197.418442,678.712830 196.497314,682.999451 
	C195.757065,686.444275 197.585403,689.605164 197.560608,693.000427 
	C197.542343,695.499939 199.588974,695.441711 201.498856,695.526001 
	C214.377960,696.094604 227.170135,694.547546 239.997269,693.942017 
	C251.670975,693.390930 263.158997,691.140381 274.478455,688.410706 
	C290.385590,684.574585 305.375336,678.448059 317.450653,666.948181 
	C325.772919,659.022461 331.523987,649.375488 335.615295,638.543579 
	C339.192871,629.071838 341.312225,619.234070 343.200684,609.442261 
	C344.291412,603.786926 344.874146,597.827209 345.396149,591.990723 
	C346.138214,583.693970 345.850616,575.306335 346.559692,567.005127 
	C348.622925,542.850220 346.901550,518.663025 347.500183,494.500000 
	C347.695709,486.607727 346.860382,484.858978 338.498688,485.482208 
	C336.841217,485.605713 335.166656,485.500000 333.500000,485.500000 
" />
			</svg>

			<div className="name-container">
				<div className="logo-name">Amanta</div>
			</div>
		</div>
	);
}
